<template>
	<vx-card>
		<div class="vx-row">
			<div class="vx-col sm:w-1/2 w-full mb-2">
				<h3>Ajouter un netlink</h3>
			</div>
			<!-- BOUTON DE RETOUR -->
			<div class="vx-col sm:w-1/2 w-full mb-2">
				<vs-button
					class="float-right"
					radius
					color="primary"
					type="filled"
					icon-pack="feather"
					icon="icon-x"
					@click="returnPrevRoute"
				></vs-button>
			</div>
			<!-- /BOUTON DE RETOUR -->
		</div>
		<div class="vx-row mb-2">
			<vx-card>
				<div class="vx-row w-full">
					<div class="vx-col mb-2">
						<label for="" class="vs-select--label">Société</label>
						<vs-select
							:disabled="isLockNetlinkSelection"
							v-model="society_id"
							class="select-large"
							placeholder="Société"
							autocomplete
							:style="styleValidator('society_id')"
							@change="validateOne(society_id, 'society_id')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in societies"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['society_id'] &&
								validators['society_id'].errText !== ''
							"
							:text="errText('society_id')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
					<div class="vx-col mb-2">
						<label for="" class="vs-select--label">Contrat</label>
						<vs-select
							:disabled="isLockNetlinkSelection"
							autocomplete
							v-model="selectedContract"
							class="select-medium mr-2"
							:style="styleValidator('selectedContract')"
							@change="validateOne(selectedContract, 'selectedContract')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.id + ' - ' + products_categories[item.delivery - 1]"
								v-for="(item, index) in contractOptions"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedContract'] &&
								validators['selectedContract'].errText !== ''
							"
							:text="errText('selectedContract')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
					<div v-if="!dns_id" class="vx-col mb-2">
						<label for="" class="vs-select--label"
							>Netlink acheté ou Netlink NDD ?</label
						>
						<vs-select
							:disabled="isLockNetlinkSelection"
							autocomplete
							v-model="newLinkTypeCategory"
							class="w-full select-medium mr-2"
							:style="styleValidator('newLinkTypeCategory')"
							@change="validateOne(newLinkTypeCategory, 'newLinkTypeCategory')"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in linkTypesCategories"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['newLinkTypeCategory'] &&
								validators['newLinkTypeCategory'].errText !== ''
							"
							:text="errText('newLinkTypeCategory')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
					<!-- <div class="vx-col mb-2">
                <vs-button>Go</vs-button>
              </div> -->
					<!-- <div v-if="dns_id || newLinkTypeCategory == 1" class="vx-col mb-2">
                <vs-select
                  :disabled="isLockNetlinkSelection"
                  autocomplete
                  v-model="newLinkType"
                  class="w-full select-medium mr-2"
                  placeholder="Type lien"
                  label="Type lien"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in linkTypesDns"
                    class="w-full"
                  />
                </vs-select>
              </div> -->
					<!-- <div v-if="!dns_id && newLinkTypeCategory == 0" class="vx-col mb-2">
                <vs-select
                  autocomplete
                  v-model="newLinkType"
                  class="w-full select-medium mr-2"
                  placeholder="Type lien"
                  label="Type lien"
                >
                  <vs-select-item
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                    v-for="(item, index) in linkTypes"
                    class="w-full"
                  />
                </vs-select>
              </div>
              <div class="vx-col" v-if="isDNSNetlink != null && isDNSNetlink == true">
                <vs-select
                    :disabled="isLockNetlinkSelection"
                    autocomplete
                    v-model="selectedDns"
                    class="select-medium mb-2"
                    placeholder="NDD"
                    label="Nom de domaine"
                    :style="styleValidator('selectedDns')"
                    @change="validateOne(selectedDns, 'selectedDns')"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.host"
                      v-for="(item, index) in dns"
                      class="w-full"
                    />
                </vs-select>
                <vx-tooltip v-if="validators['selectedDns'] && validators['selectedDns'].errText !== ''" :text="errText('selectedDns')" class="ml-3">
                  <vs-icon icon="error" size="medium" style="color:red;"></vs-icon>
                </vx-tooltip>
              </div> -->
					<div class="vx-col" v-if="!dns_id && newLinkTypeCategory == 0">
						<label for="" class="vs-select--label">Prestataire</label>
						<vs-select
							:disabled="isLockNetlinkSelection"
							v-model="selectedProvider"
							class="w-full select-medium mr-2"
							autocomplete
							:style="styleValidator('selectedProvider')"
							@change="validateOne(selectedProvider, 'selectedProvider')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.society"
								v-for="(item, index) in netlinkProviders"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['selectedProvider'] &&
								validators['selectedProvider'].errText !== ''
							"
							:text="errText('selectedProvider')"
							class="ml-3"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
					<!-- <div v-if="!dns_id && newLinkTypeCategory == 0" class="vx-col">
                <vs-input
                  :disabled="isLockNetlinkSelection"
                  class="w-full"
                  label="Prix de l'ensemble des netlinks (location homepage incluse)"
                  v-model="purchasePrice"
                />
              </div> -->
					<div class="vx-col pt-5">
						<vs-button
							v-if="isLockNetlinkSelection == false"
							@click="lockNetlinkSelection"
							>Valider</vs-button
						>
						<vs-button
							v-if="isLockNetlinkSelection == true"
							@click="unlockNetlinkSelection"
							>Déselectionner</vs-button
						>
					</div>
				</div>
			</vx-card>
		</div>
		<!-- <div v-if="isDNSNetlink != null && isDNSNetlink == false" class="vx-row">
        <vx-card>
          <NewPurchasePopup ref="netlinkPurchasePopup" type="Netlink"  :selectedSociety="society_id" :selectedContract="selectedContract" :isNetlinkPurchase="true" />
        </vx-card>
      </div> -->
		<!-- <div class="vx-row">
        <vx-card v-if="isDNSNetlink != null && isDNSNetlink == true">
          <div v-if="isDNSNetlink != null && isDNSNetlink == true" class="vx-row"> -->
		<!-- <div class="vx-col">
                <vs-select
                    autocomplete
                    v-model="selectedDns"
                    class="select-medium mb-2"
                    placeholder="NDD"
                    label="Nom de domaine"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.id"
                      :text="item.host"
                      v-for="(item, index) in dns"
                      class="w-full"
                    />
                  </vs-select>
              </div> -->
		<!-- <div class="vx-col">
                <vs-button @click="showDns">Nouveau NDD</vs-button>
              </div> -->
		<!-- </div> -->
		<!-- <div class="vx-row">
            <div v-if="isDNSNetlink != null && isDNSNetlink == true && showNewDNS" class="vx-row">
              <div class="vx-col w-full">
                <div class="vx-row w-full">
                  <div class="vx-col">
                    <h3>Nouveau Nom de domaine</h3>
                  </div>
                  <div class="vx-col">
                    <vs-button
                      class="float-right"
                      radius
                      color="primary"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-x"
                      @click="closeDns"
                    ></vs-button>
                  </div>
                </div>
                <div class="vx-row w-full pl-3">
                  <NewPurchasePopup ref="dnsPurchasePopup" type="DNS" :isFromNDD="true" :selectedSociety="society_id" :selectedContract="selectedContract" />
                </div>
              </div>
            </div>
          </div> -->
		<!-- </vx-card>
      </div> -->
		<div class="vx-row mt-2" v-if="isLockNetlinkSelection">
			<vx-card>
				<NewNetlinkPopupTable
					ref="netlinkPopup"
					:societyId="society_id"
					:showNetlinkBuyer="true"
					:isFromNDD="newLinkTypeCategory"
					:linkType="newLinkType"
					@update-total-price="updateTotalPrice($event)"
				/>
			</vx-card>
		</div>
		<!-- <div class="vx-row mt-2" v-if="newLinkType != null && selectedProvider != null">
        <vx-card>
          <div class="vx-row">
            <vs-spacer/><strong class="vx-col">Total du prix des netlinks : {{purchasePrice}}€</strong>
          </div>
        </vx-card>
      </div> -->
		<div class="vx-row my-2 float-right" v-if="isLockNetlinkSelection == true">
			<vs-button @click="submitForm">Enregistrer</vs-button>
		</div>
	</vx-card>
</template>

<script>
import VueCookies from "vue-cookies";
import Contract from "@/entities/Contract";
import Netlink from "@/entities/Netlink";
import Purchase from "@/entities/Purchase";
import Dns from "@/entities/Dns";
import Validator from "@/entities/Validator";

import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";

import NewNetlinkPopupTable from "@/components/tables/NewNetlinkPopupTable";
import VxTooltip from "./../../../components/widgets/vx-tooltip/VxTooltip.vue";

import store from "@/store/store";

export default {
	name: "NetlinkForm",
	mixins: [dbFieldConvertor],
	components: {
		NewNetlinkPopupTable,
		VxTooltip,
	},
	props: {
		dns_id: String,
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			// FORM SELECT OPTIONS
			societyOptions: [],
			contractOptions: [],
			linkTypes: [],
			linkTypesCategories: [
				{ text: "Netlink acheté", value: 0 },
				{ text: "Netlink NDD", value: 1 },
			],

			// VARIABLES
			isLockNetlinkSelection: false,

			society_id: null,
			selectedContract: null,

			selectedDns: null,
			oneDns: Dns.getFormFields(),
			dnsProviders: [],

			netlink_list: [],
			netlinkService: null,
			newLinkTypeCategory: null,
			newLinkType: null,
			netlink: Netlink.getFormFields(),
			netlinkProviders: [],

			purchaseId: null,
			purchase: Purchase.getFormFields(),
			purchasePrice: 0,

			selectedProvider: null,
			providerId: null,

			isDNSNetlink: null,
			showNewDNS: false,
			validators: {},
			check: true,
		};
	},
	watch: {
		society_id: function (data) {
			//console.log("selectedSociety watch");
			// this.purchase.contract_society_id = this.selectedSociety
			this.getAllContractsForSociety(data);
		},
		/*
		 * netlink_types: function(data){
		 *   this.linkTypes = data.filter(row => row.is_dns == 0)
		 * },
		 */
		newLinkType: function (data) {
			this.isDNSNetlink = this.checkLinkTypeIsDNS(data);
		},
		dns_id: function (data) {
			this.selectedDns = data;
		},
		providers: function () {
			this.createNetlinkProviderList();
			this.createDNSProviderList();
		},
		services: function () {
			this.createNetlinkProviderList();
			this.createDNSProviderList();
		},
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	created() {
		this.getAllNetlinkTypes();
		this.getAllProviders();
		this.getAllServices();
		this.getAllSociety();
		this.getAllProductsCategories();
		this.createDNSProviderList();
		this.createNetlinkProviderList();
		this.getAllDns();
		if (this.$props.dns_id) {
			this.selectedDns = this.$props.dns_id;
		}
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		societies: () => {
			return store.state.societies;
		},
		dns: () => {
			return store.state.dns;
		},
		netlink_types: () => {
			return store.state.netlink_types;
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		products_categories: () => {
			return store.state.products_categories.map((row) => row.name);
		},
	},
	methods: {
		isRecurringLink(link_type) {
			let foundIndex = this.netlink_types.findIndex(
				(row) => row.id == link_type
			);
			if (foundIndex >= 0) {
				if (this.netlink_types[foundIndex].recurrency == 1) return true;
			}
			return false;
		},
		lockNetlinkSelection() {
			this.check = true;
			let fields = [
				"society_id",
				"selectedContract",
				"newLinkTypeCategory",
				"selectedProvider",
			];
			let fieldsVal = [
				this.society_id,
				this.selectedContract,
				this.newLinkTypeCategory,
				this.selectedProvider,
			];
			for (let i = 0; i < fields.length; i++) {
				let name = "isNumberConstraint";
				let value = fieldsVal[i];
				value === 0 ? (value = "0") : "";
				value ? (value = String(value)) : "";
				value == null ? (value = "") : "";
				this.validators[fields[i]] = new Validator({ constraintName: name });
				this.validators[fields[i]].check(value);
				if (
					this.validators[fields[i]].valid == false &&
					this.validators[fields[i]].errText == ""
				) {
					if (
						this.newLinkTypeCategory == 1 &&
						fields[i] == "selectedProvider"
					) {
						//
					} else if (this.dns_id && fields[i] == "newLinkTypeCategory") {
					} else if (this.dns_id && fields[i] == "selectedProvider") {
					} else {
						this.validators[fields[i]].errText = "Ce champ ne peut être vide.";
						this.check = false;
					}
				}
				this.$forceUpdate();
			}
			if (this.check == false) {
				//console.log(this.validators);
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				// ADD Check parameters
				this.isLockNetlinkSelection = true;
				if (this.newLinkTypeCategory == 1) {
					this.newLinkType = 3;
					this.selectedProvider = null;
				}
			}
		},
		unlockNetlinkSelection() {
			// ADD Check parameters
			this.isLockNetlinkSelection = false;
		},
		updateTotalPrice(price) {
			// this.purchasePrice = price
		},

		validateOne(val, name) {
			let value = val;
			value === 0 ? (value = "0") : "";
			let constname = "";
			switch (name) {
				case "society_id":
				case "selectedContract":
				case "selectedDns":
				case "selectedProvider":
				case "newLinkTypeCategory":
					value ? (value = String(val)) : "";
					value == null ? (value = "") : "";
					constname = "isNumberConstraint";
					break;
				case "max_budget":
					constname = "priceConstraint";
					break;
				default:
					return "";
			}
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			this.validators[name].valid == false &&
			this.validators[name].errText == ""
				? (this.validators[name].errText = "Ce champ ne peut être vide.")
				: "";
			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				return "border: 1px solid red !important; border-radius: 5px;";
			} else if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].errText == ""
			) {
				return "border: 1px solid green !important; border-radius: 5px;";
			} else {
				return "border: none !important; border-radius: none;";
			}
		},

		addPurchase(isDNS = false) {
			return new Promise((resolve, reject) => {
				/*
				 * if(isDNS == false){
				 *   // this.purchase = this.$refs.dnsPurchasePopup.getPurchaseData()
				 * }else{
				 *   purchasePrice
				 *   this.purchase = this.$refs.netlinkPurchasePopup.getPurchaseData()
				 * }
				 */
				let today = new Date(Date.now());
				let formatedDate = this.purchase.boughtAt
					? this.purchase.boughtAt.substring(0, 10)
					: today.toISOString().substring(0, 10);

				formatedDate = formatedDate.split("/").reverse().join("-");
				formatedDate = formatedDate + " 02:00:00";
				this.$http
					.post(this.apiUrl + "purchase/add", {
						price: this.$refs.netlinkPopup.getPurchasePrice(),
						recurrence: this.purchase.recurrence,
						margin_price: this.convertFrenchNumberToInternational(
							this.purchase.marginPrice
						),
						margin_rate: this.purchase.marginRate,
						is_billable: this.purchase.isBillable,
						commentary: this.purchase.commentary,
						bought_at: formatedDate,
						contract_id: this.selectedContract,
						contract_society_id: this.society_id,
						users_id: this.selectedProvider,
						service_id: this.netlinkService,
						is_delivered: 0,
						recurrence_active: this.purchase.recurrence,
						user_id: this.activeUser.id,
					})
					.then((res) => {
						// //console.log(res)
						this.purchaseId = res.data.insertId;
						/*
						 * //console.log(this.purchaseId)
						 * this.showNetlinkPopup = true
						 */
						this.$store.dispatch("getAllPurchasesWithRecurring");
						// Send a success notification to the user
						this.$vs.notify({
							title: "Succès",
							text: "Achat ajouté avec succès.",
						});
						resolve(res.data.insertId);
					})
					.catch((err) => {
						//console.log(err);
						this.$vs.notify({
							title: "Echec",
							text: "L'achat n'a pas été ajouté.",
						});
						reject(null);
					});
			});
		},

		addDNS() {
			// CREATE DNS OBJECT
			return new Promise((resolve, reject) => {
				this.oneDns = this.$refs.dnsPurchasePopup.getDnsPopup();
				//console.log("this.purchaseId", this.purchaseId);
				if (this.purchaseId) {
					//console.log(this.purchaseId);
					this.oneDns.purchase_id = this.purchaseId;
				}
				if (this.providerId) {
					//console.log(this.providerId);
					this.oneDns.provider_id = this.providerId;
				}
				let formatedDate = this.oneDns.purchase_date
					.split("/")
					.reverse()
					.join("-");
				this.oneDns.purchase_date = formatedDate;
				this.oneDns.renew_date = formatedDate;
				let newDns = new Dns(this.oneDns);
				//console.log(newDns);
				newDns.create((err, res) => {
					if (err) {
						//console.log(err);
						reject(err);
					}
					if (res) {
						//console.log(res);
						this.$store.dispatch("getAllDns");
						resolve(res.data.insertId);
					}
				});
			});
		},

		createNetlink(isDNS, netlink) {
			return new Promise((resolve, reject) => {
				/*
				 * this.netlink =
				 * this.netlink.landingPage = this.netlink.landingPage;
				 * this.netlink.urlBought = this.netlink.urlBought;
				 */

				/*
				 * if(isDNS){
				 *   netlink.dns_id = this.selectedDns
				 * }
				 */

				if (this.purchaseId) {
					//console.log(this.purchaseId);
					netlink.purchase_id = this.purchaseId;
				}
				//console.log("this.society_id", this.society_id);
				if (this.society_id) {
					//console.log(this.society_id);
					netlink.society_id = this.society_id;
				}

				//console.log("this.selectedContract", this.selectedContract);
				if (this.selectedContract) {
					//console.log(this.selectedContract);
					netlink.contract_id = this.selectedContract;
				}

				/*
				 * let newNetlink = new Netlink(netlink)
				 * //console.log(newNetlink)
				 */
				netlink.create((err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							//console.log(res.data.insertId);
							this.$store.dispatch("getAllNetlink");
							netlink.id = res.data.insertId;
							// this.netlink_list.push(newNetlink)
							resolve(res.data.insertId);
						}
				});
			});
		},

		addNetlink(isDNS = false) {
			// IMPLEMENT DNS LINKING
			return new Promise((resolve, reject) => {
				this.netlink_list = this.$refs.netlinkPopup.getNetlinkListData();
				let requests = [];
				for (let netlink of this.netlink_list) {
					netlink.provider_id = this.selectedProvider;
					requests.push(this.createNetlink(isDNS, netlink));
				}
				Promise.all(requests).then((responses) => {
					resolve(responses);
				});
			});
		},

		submitForm() {
			return new Promise((resolve, reject) => {
				if (this.$refs.netlinkPopup.netlink_list.length == 0) {
					this.$vs.notify({
						title: "Echec",
						text: "Veuillez ajouter au moins un netlink.",
					});
					return;
				} else {
					if (this.newLinkTypeCategory == 1) {
						if (this.showNewDNS == true) {
							// // Purchase DNS
							// this.addPurchase(true)
							// .then(result => {
							//   // Add DNS
							//   this.addDNS()
							//   .then(result2 => {
							//     this.selectedDns = result2
							//     // Add Netlink to DNS
							//     this.addNetlink(true)
							//     .then(result3 => {this.returnPrevRoute(); resolve(result3)})
							//     .catch(err3 => {//console.log(err3); reject(err3)})
							//   })
							//   .catch(err2 => {//console.log(err2); reject(err2)})
							// })
							// .catch(err => {//console.log(err); reject(err)})
						} else {
							// Add Netlink to DNS
							this.addNetlink(true)
								.then((result) => {
									this.returnPrevRoute();
									resolve(result);
								})
								.catch((err) => {
									//console.log(err); reject(err);
								});
						}
					} else {
						// Purchase Netlink
						this.addPurchase()
							.then((result) => {
								// Add Netlink
								this.addNetlink()
									.then((result2) => {
										this.returnPrevRoute();
										resolve(result2);
									})
									.catch((err2) => {
										//console.log(err2); reject(err2);
									});
							})
							.catch((err) => {
								//console.log(err); reject(err);
							});
					}
				}
			});
		},

		showDns() {
			this.showNewDNS = true;
		},
		closeDns() {
			this.showNewDNS = false;
		},
		checkLinkTypeIsDNS(linkTypeId) {
			let foundLinkType = this.netlink_types.find(
				(row) => row.id == linkTypeId
			);
			if (foundLinkType) {
				if (foundLinkType.is_dns == 1) {
					return true;
				}
			}

			return false;
		},

		createDNSProviderList() {
			//Find DNS service id
			let dnsService = this.services.find((service) => service.name == "NDD");
			//console.log("dnsService", this.services, dnsService);
			//Filter Providers on service id
			let dnsProviderList = [];
			if (dnsService) {
				dnsProviderList = this.providers.filter((provider) =>
					provider.service_id_list
						? provider.service_id_list
								.split(",")
								.indexOf(dnsService.id.toString()) >= 0
						: false
				);
			}
			this.dnsProviders = dnsProviderList;
		},

		createNetlinkProviderList() {
			//Find Netlink service id
			let netlinkService = this.services.find(
				(service) => service.name == "Netlinking"
			);
			this.netlinkService = netlinkService.id;
			//console.log("netlinkService", this.services, netlinkService);
			//Filter Providers on service id
			let netlinkProviderList = [];
			if (netlinkService) {
				netlinkProviderList = this.providers.filter((provider) =>
					provider.service_id_list
						? provider.service_id_list
								.split(",")
								.indexOf(netlinkService.id.toString()) >= 0
						: false
				);
			}
			this.netlinkProviders = netlinkProviderList;
		},

		getAllProductsCategories() {
			this.$store.dispatch("getAllProductsCategories");
		},

		getAllNetlinkTypes() {
			this.$store.dispatch("getAllNetlinkTypes");
		},

		getAllServices() {
			this.$store.dispatch("getAllServices");
		},

		getAllProviders() {
			this.$store.dispatch("getAllProviders");
		},

		getAllDns() {
			this.$store.dispatch("getAllDns");
		},

		getAllSociety() {
			this.$store.dispatch("getAllSocieties");
		},

		getAllContractsForSociety(societyId) {
			Contract.getContractsforSociety(societyId, (err, res) => {
				if (err)
					if (res) {
						//console.log(err);
						this.contractOptions = res;
						//console.log("this.contractOptions.length", this.contractOptions.length);
						if (this.contractOptions.length > 0) {
							this.selectedContract = this.contractOptions[0].id;
						} else {
							this.selectedContract = null;
						}
					}
			});
			//console.log("getAllContractsForSociety");
		},

		/**
		 * Send the data to tha API to create the new user
		 * If the form is successfully sent, the user is redirect to Providers.vue
		 */
		formSubmitted() {},

		/**
		 * Redirect to the previous page
		 */
		returnPrevRoute() {
			this.$router.go(-1);
		},
	},
};
</script>

<style scoped>
.role_selector_container {
	justify-content: space-between;
	width: 40%;
}

.role_container {
	justify-content: center;
}

.space_div {
	margin: 5px;
}

.bottom {
	align-self: flex-end;
}

.right_element {
	justify-content: flex-end;
}
</style>

